<div class="px-2 md:px-10 pt-2 md:pt-5 font-bold overflow-y-auto h-74 md:h-88">
  <h1 class="w-full text-center text-3xl mb-10">
    {{ "termsConditions.title" | translate }}
  </h1>
  <pre class="pb-10">
  {{ "termsConditions.content.part1" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.definitionsTitle" | translate }}</h2>
  {{ "termsConditions.content.definitions" | translate }}

  {{ "termsConditions.content.definition1" | translate }}
  {{ "termsConditions.content.definition2" | translate }}
  {{ "termsConditions.content.definition3" | translate }}
  {{ "termsConditions.content.definition4" | translate }}
  {{ "termsConditions.content.definition5" | translate }}
  {{ "termsConditions.content.definition6" | translate }}
  {{ "termsConditions.content.definition7" | translate }}
  {{ "termsConditions.content.definition8" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.usageTitle" | translate }}</h2>
  {{ "termsConditions.content.usageSubtitle1" | translate }}

  {{ "termsConditions.content.usageSubtitle1Desc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.usageSubtitle2" | translate }}</h2>
  {{ "termsConditions.content.usageSubtitle2Desc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.usageSubtitle3" | translate }}</h2>
  <span [innerHTML]='"termsConditions.content.usageSubtitle3Desc" | translate'>{{ "termsConditions.content.usageSubtitle3Desc" | translate }}</span>

  <h2 class="text-primary_text">{{ "termsConditions.content.servicesTitle" | translate }}</h2>
  {{ "termsConditions.content.servicesDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.transmissionTitle" | translate }}</h2>
  {{ "termsConditions.content.transmissionDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.storageTitle" | translate }}</h2>
  {{ "termsConditions.content.storageDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.obligationsVyvTitle" | translate }}</h2>
  {{ "termsConditions.content.obligationsVyvDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.obligationsUserTitle" | translate }}</h2>
  {{ "termsConditions.content.obligationsUserDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.securityTitle" | translate }}</h2>
  {{ "termsConditions.content.securityDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.intellectualPropertyTitle" | translate }}</h2>
  {{ "termsConditions.content.intellectualPropertyDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.traceabilityTitle" | translate }}</h2>
  {{ "termsConditions.content.traceabilityDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.conservationTitle" | translate }}</h2>
  {{ "termsConditions.content.conservationDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.evidenceTitle" | translate }}</h2>
  {{ "termsConditions.content.evidenceDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.liabilityTitle" | translate }}</h2>
  {{ "termsConditions.content.liabilityDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.cookiesTitle" | translate }}</h2>
  {{ "termsConditions.content.cookiesDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.cookiesDefinitionTitle" | translate }}</h2>
  {{ "termsConditions.content.cookiesDefinitionDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.cookiesByWhomTitle" | translate }}</h2>
  {{ "termsConditions.content.cookiesByWhomDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.cookiesUsedTitle" | translate }}</h2>
  {{ "termsConditions.content.cookiesUsedDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.cookiesBasisTitle" | translate }}</h2>
  {{ "termsConditions.content.cookiesBasisDesc" | translate }}

  <h2 class="text-primary_text">{{ "termsConditions.content.modificationTitle" | translate }}</h2>
  {{ "termsConditions.content.modificationDesc" | translate }}
  </pre>
</div>
